// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yS5E3","title":"styles_title__3T_aB"};